import { IPublicClientApplication } from '@azure/msal-browser';
import { RoleName } from '../../models';
import { ApiEndpointCallStatesStore } from '../api-endpoint-call-states-store';
import { FetchContext } from '../fetch-context';
import { promiseWithObservableState } from '../promise-with-observable-state';
import { withApiAccessToken } from '../with-api-access-token';
import {
  endUserImpersonation,
  getUserImpersonation,
  getUserImpersonationRoles,
  startUserImpersonation,
} from './index';

export const createUserImpersonationsApiEndpoints = (
  fetchContext: FetchContext,
  apiEndpointCallStates: ApiEndpointCallStatesStore,
) => ({
  getUserImpersonationRoles: (instance: IPublicClientApplication) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => getUserImpersonationRoles(fetchContext, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('getUserImpersonationRoles', isInFlight);
    },
  ),
  getUserImpersonation: (instance: IPublicClientApplication) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => getUserImpersonation(fetchContext, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('getUserImpersonation', isInFlight);
    },
  ),
  startUserImpersonation: (instance: IPublicClientApplication, role: RoleName) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => startUserImpersonation(fetchContext, role, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('startUserImpersonation', isInFlight);
    },
  ),
  endUserImpersonation: (instance: IPublicClientApplication) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => endUserImpersonation(fetchContext, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('endUserImpersonation', isInFlight);
    },
  ),
});
